import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function LatestUpdates() {
  const latestComics = comics.slice(4, 10);

  return (
    <section className="py-14 md:py-20 bg-background-50" aria-labelledby="latest-title">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-end justify-between mb-10">
            <div>
              <span className="text-xs font-medium text-accent-600 uppercase tracking-wider">每日更新</span>
              <h2 id="latest-title" className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-2">
                最新<span className="italic font-normal text-accent-500">更新</span>
              </h2>
            </div>
            <Link to="/" className="hidden sm:flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              更多更新 <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
            {latestComics.map((comic) => (
              <Link
                key={comic.id}
                to={`/comic/${comic.id}`}
                className="group bg-background-100 rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
              >
                <div className="aspect-[3/4] overflow-hidden">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="p-3">
                  <h3 className="font-sans text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
                    {comic.title}
                  </h3>
                  <div className="flex items-center gap-2 mt-1.5">
                    <span className="text-xs text-foreground-500">{comic.chapters[0].num}话</span>
                    <span className="w-1 h-1 rounded-full bg-accent-500"></span>
                    <span className="text-xs text-accent-500">{comic.updatedAt}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}